import React from "react";
import { Route } from "react-router-dom";
import UserInfo from "./userInfo";
import IntegraDetails from "./IntegraDetails";
import VipRecord from "./vipRecord";
import GrantRecord from "./grantRecord";
import BankRecord from "./bankRecord";
import SmallProgramSet from "./smallProgramSet";
import Rules from "./rules";
import ViewQuestion from "./viewQuestion";
import RecommendGoods from "./recommendGoods";
import ActivityDetails from "./activityDetails";
import HistoryActivityDetails from "./historyActivityDetails";
import ActivityCenter from "./activityCenter";
import Manual from "./manual";
import Question from "./question";
import Questionnaire from "./questionnaire/index"; // 问卷详情
const Router = ({ match }) => {
  return (
    <React.Fragment>
      <Route path={`${match.path}/userInfo`} component={UserInfo}></Route>
      <Route path={`${match.path}/vipRecord`} component={VipRecord}></Route>
      <Route path={`${match.path}/grantRecord`} component={GrantRecord}></Route>
      <Route path={`${match.path}/bankRecord`} component={BankRecord}></Route>
      <Route path={`${match.path}/manual`} component={Manual}></Route>
      <Route path={`${match.path}/question/:id`} component={Question}></Route>
      <Route
        path={`${match.path}/questionnaire/:id`}
        component={Questionnaire}
      ></Route>

      <Route
        path={`${match.path}/viewQuestion/:id`}
        component={ViewQuestion}
      ></Route>
      <Route path={`${match.path}/rules`} component={Rules}></Route>
      <Route
        path={`${match.path}/smallProgramSet`}
        component={SmallProgramSet}
      ></Route>
      <Route
        path={`${match.path}/recommendGoods`}
        component={RecommendGoods}
      ></Route>
      <Route
        path={`${match.path}/activityCenter`}
        component={ActivityCenter}
      ></Route>
      <Route
        path={`${match.path}/integraDetails/:id`}
        component={IntegraDetails}
      ></Route>
      <Route
        path={`${match.path}/activityDetails/:id`}
        component={ActivityDetails}
      ></Route>
      <Route
        path={`${match.path}/historyActivityDetails/:id`}
        component={HistoryActivityDetails}
      ></Route>
    </React.Fragment>
  );
};
export default Router;
